import VarnishTheme from '@allenai/varnish-theme';
// eslint-disable-next-line import/no-unresolved
import { Color } from '@allenai/varnish2/theme';

export const paperFinderTheme = {
  // extend or override colors
  color: {
    main: {
      primary: VarnishTheme.color['green-100'].value,
      secondary: VarnishTheme.color['pink-100'].value,
      inactive: VarnishTheme.color['gray-50'].value,
    },
    text: {
      primary: new Color('White', '#FAF2E9', undefined, true),
      secondary: VarnishTheme.color['gray-30'].value,
    },
    background: {
      primary: '#0d2f30',
      secondary: VarnishTheme.color['dark-teal-100'].value,
      conversation: {
        client: VarnishTheme.palette.dark.charting.categorical.dark.Aqua.value,
        agent: VarnishTheme.palette.dark.charting.categorical.dark.Green.value,
      },
      paper: {
        primary: '#163638',
        secondary: '#0C292C',
      },
    },
    checkbox: {
      primary: VarnishTheme.color['gray-50'].value,
    },
    border: {
      primary: 'rgb(131 131 131 / 60%)',
      secondary: 'rgb(131 131 131 / 20%)',
      hover: VarnishTheme.color['gray-10'].value,
    },
    scrollbar: {
      thumb: VarnishTheme.color['dark-teal-100'].value,
      track: '#135458',
    },
    loader: {
      bar: 'rgb(15, 203, 140)',
    },
  },
  other: {
    relevance: {
      notRelevant: new Color('Red', '#FF4544', undefined, true),
      related: new Color('Orange', '#FFA31C', undefined, true),
      relevant: new Color('Green', '#D6CB00', undefined, true),
      perfectlyRelevant: new Color('Dark Green', '#549C35', undefined, true),
    },
  },
  font: {
    size: {
      small: '14px',
      semimedium: '15px',
      medium: '16px',
      semilarge: '18px',
      large: '20px',
      xlarge: '30px',
    },
    family: {
      primary: 'Manrope',
      secondary: 'Arial, sans-serif',
      heading: 'Manrope',
    },
  },
  border: {
    radius: {
      small: '2px',
      medium: '4px',
      mediumLarge: '6px',
      large: '8px',
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: VarnishTheme.color['green-100'].value,
          '&.MuiTypography-root:hover': {
            color: VarnishTheme.color['green-100'].value,
            transition: 'unset',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: '0px',
          marginLeft: '0px',
        },
        label: {
          color: '#FAF2E9',
          fontFamily: 'Manrope',
          '&.Mui-disabled': {
            color: VarnishTheme.color['gray-50'].value,
            opacity: 0.7,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: () => ({
          color: '#FAF2E9',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: VarnishTheme.color['gray-50'].value,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: VarnishTheme.color['gray-30'].value,
          },
          '& .MuiSvgIcon-root': {
            color: VarnishTheme.color['gray-50'].value,
          },
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: () => ({
          fontSize: '14px',
          fontWeight: 400,
          fontFamily: 'Manrope',
          color: VarnishTheme.color['green-100'].value,
          '&.Mui-disabled': {
            background: 'transparent',
            color: VarnishTheme.color['gray-50'].value,
            opacity: 0.5,
            cursor: 'not-allowed',
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: () => ({
          color: VarnishTheme.color['green-100'].value,
          fontSize: '14px',
          '&.Mui-disabled': {
            background: 'transparent',
            color: VarnishTheme.color['gray-50'].value,
            opacity: 0.5,
            cursor: 'not-allowed',
          },
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: () => ({
          color: '#FAF2E9',
          padding: '4px',
          '&.Mui-checked': {
            color: '#FAF2E9',
          },
          '&.Mui-disabled': {
            color: VarnishTheme.color['gray-50'].value,
            opacity: 0.7,
          },
          '.MuiSvgIcon-root': {
            fontSize: '22px',
          },
        }),
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: () => ({
          width: '100%',
          height: '100%',
          overflow: 'auto',
          '&:hover': {
            overflow: 'auto',
          },
        }),
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: () => ({
          backgroundColor: 'rgba(12, 42, 43, 1)',
          color: '#FAF2E9',
          '&.Mui-expanded': {
            margin: '2px 0px',
          },
          '& .MuiAccordionSummary-root': {
            padding: '0px 16px',
            minHeight: '42px',
            '& .MuiAccordionSummary-content': {
              margin: '0px 0px',
            },
            '.MuiSvgIcon-root': {
              color: '#ffffff8f',
            },
            '&.Mui-expanded': {
              minHeight: '40px',
            },
          },
          '& .MuiAccordionDetails-root': {
            maxHeight: '174px',
            margin: '8px 5px 8px 10px',
            padding: '0px',
            overflow: 'hidden',
          },
        }),
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: () => ({
          '& .MuiPaginationItem-root': {
            color: '#FAF2E9',
            fontWeight: 400,
            fontSize: '14px',
            fontFamily: 'Manrope',
          },
          '& .MuiPaginationItem-root.Mui-selected,.MuiPaginationItem-root.Mui-selected:hover':
            {
              backgroundColor: 'rgba(255, 255, 255, 0.16)',
            },
          '& .MuiPaginationItem-root:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
          '& button.MuiPaginationItem-root': {
            width: '28px',
            minWidth: '28px',
            height: '28px',
          },
        }),
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: () => ({
          color: '#FAF2E9',
          padding: '4px',
          '& .MuiSvgIcon-root': {
            width: '20px',
            height: '20px',
          },
          '&.Mui-checked': {
            color: '#0FCB8C',
          },
          '&.Mui-disabled': {
            color: VarnishTheme.color['gray-50'].value,
            opacity: 0.7,
          },
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: () => ({
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(250, 242, 233)',
          },
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: () => ({
          '&.MuiInputBase-multiline.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgb(250, 242, 233)',
            },
        }),
      },
    },
  },
};
